import { render, staticRenderFns } from "./GiftWithdrawElement.vue?vue&type=template&id=004107b3&scoped=true"
import script from "./GiftWithdrawElement.vue?vue&type=script&lang=js"
export * from "./GiftWithdrawElement.vue?vue&type=script&lang=js"
import style0 from "./GiftWithdrawElement.vue?vue&type=style&index=0&id=004107b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004107b3",
  null
  
)

export default component.exports